import React, { useState, useEffect, useRef, useContext } from "react";
import styles from "./ConfigMembershipCNCStoreAndServicesWrapper.module.css";
import { FaCheck, FaTimes } from "react-icons/fa";
import { BASE_URL_API } from "../../References/URLs";
import AuthContext from "../../store/auth-context";
import ActiveStoreContext from "../../store/ActiveStoreContext";
import { MdCheckBox, MdCheckBoxOutlineBlank, MdOutlineCheckBoxOutlineBlank } from "react-icons/md";

const ConfigMembershipCNCStoreAndServicesWrapper = (props) => {
    const { configurations, configurationHandler } = props
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext)
    const activeStore = (() => { try { return asCtx?.activeStore && asCtx.activeStore.trim() !== "" ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();
    const vendorIdentifier = JSON.parse(authCtx?.loginData)?.partnersData?.vendorIdentifier

    const [stores, setStores] = useState([])
    const [cardPreview, setCardPreview] = useState({
        redeemableStores: [],
        redeemableServices: [],
    });


    const services = [
        { identifier: "1", label: "Haircut" },
        { identifier: "2", label: "Manicure" },
        { identifier: "3", label: "Pedicure" },
    ]; // Sample services

    const handleStoreSelection = (k) => {
        const currentStores = configurations?.redeemableStores || [];
        let updatedStores;

        if (currentStores?.some(store => store.storeIdentifier === k.storeIdentifier)) {
            // remove store if already selected
            updatedStores = currentStores.filter(
                store => store.storeIdentifier !== k.storeIdentifier
            );
        } else {
            // add store if not selected
            updatedStores = [...currentStores, k];
        }

        configurationHandler('redeemableStores', updatedStores);
    };



    const handleServiceSelection = (selectedServices) => {
        setCardPreview((prev) => ({
            ...prev,
            redeemableServices: selectedServices,
        }));
    };

    const getAllStores = async () => {
        const response = await fetch(BASE_URL_API + "getAllStores",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    vendorIdentifier: vendorIdentifier
                })
            })

        if (!response.ok) {
            console.log("Something went wrong : Serve Error")
        } else {
            const respo = await response.json()
            if (respo.status === "success") {
                setStores(respo?.response)
            } else {
                if (respo.message === "tokenExpired") {
                    authCtx.logout()
                } else {

                }
            }
            console.log(respo)
        }
    }


    useEffect(() => {
        getAllStores()
    }, [])



    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <div className={styles.title} >Select Store(s)</div>
                <div className={styles.listWrapper} >
                    {stores?.map((item, index) => (
                        <div key={index} className={styles.eachStoreWrapper} onClick={() => handleStoreSelection(item)} >
                            <div>
                                {configurations?.redeemableStores?.some(store => store?.storeIdentifier === item?.storeIdentifier) ? <MdCheckBox color="#037BFF" size={20} /> : <MdOutlineCheckBoxOutlineBlank color="#037BFF" size={20} />}
                            </div>

                            <div>
                                <div className={styles.storeName} >
                                    {item?.storeName}
                                </div>
                                <div className={styles.storeAddress} >
                                    {item?.storeAddress}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
export default ConfigMembershipCNCStoreAndServicesWrapper;
